const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    margin: [0, 'auto', 10],
    width: '100%'
  },
  svg: {
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0
  },
  path: {
    opacity: ({ energy }) => energy.animate ? 0 : 1
  },
  content: {
    position: 'relative',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    margin: [0, 'auto'],
    padding: [20, 20, 10],
    width: '100%',
    maxWidth: 1000
  },
  brand: {
    margin: [0, 'auto', 10],
    width: '100%',
    maxWidth: 360
  },
  menu: {
    width: '100%'
  },

  '@media screen and (min-width: 768px)': {
    root: {
      marginBottom: 20
    },
    content: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: [20, 24, 30]
    },
    brand: {
      margin: 0,
      maxWidth: 360,
      transform: 'translateX(-102px)'
    },
    menu: {
      margin: 0,
      width: 'auto',
      maxWidth: 'none',
      flexShrink: 0
    }
  },

  '@media screen and (min-width: 1025px)': {
    brand: {
      maxWidth: 360,
      transform: 'translateX(-102px)'
    },
    menu: {
      margin: 0,
      width: 'auto',
      maxWidth: 'none',
      flexShrink: 0
    }
  }
});

export { styles };

// Commit trace: 2025-08-14T02:50:44 - style: update lint compliance in Header.styles.js

// Commit trace: 2025-11-28T06:25:46 - perf: improve memory usage in Header.styles.js

// Commit trace: 2026-01-13T22:23:36 - feat: add utility helper to Header.styles.js

// Commit trace: 2026-04-06T09:04:33 - docs: clarify parameter types in Header.styles.js
